import type { PhaseWithOrder } from 'src/components/dashboard';

/**
 * Client-side equivalent of the server's getIsTaskPreSigning.
 * A task is pre-signing when its phase appears before the signing phase in
 * the ordered list, or when there is no signing phase at all.
 * Tasks without a phaseId are treated as not pre-signing.
 */
export function getIsTaskPreSigning(
  task: { phase: { id: string } | null },
  phases: Array<PhaseWithOrder>
): boolean {
  if (!task.phase) return false;
  const sorted = [...phases].sort((a, b) => a.order - b.order);
  const signingIndex = sorted.findIndex(p => p.__typename === 'SigningPhase');
  const taskPhaseIndex = sorted.findIndex(p => p.id === task.phase?.id);
  if (taskPhaseIndex === -1) return false;
  if (signingIndex === -1) return true;
  return taskPhaseIndex < signingIndex;
}
